import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { ClubList, Emptylist, PokerFrameList } from "./components";
import { openDialog } from '../../store/actionCreators/dialog';
import { resetCurrentClub } from "../../store/actionCreators/club";
import '../../assets/stylesheets/ClubSlide/ClubPage.scss';
import LeagueGamesMenu from '../League/LeagueGamesMenu';
import { getClubList } from "../../store/selectors";
import { isMobile } from 'react-device-detect';
import config from "../../config/config";
import { requestGames } from '../../store/actionCreators/casinoGames';

const Home = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const clubsData = useSelector(getClubList);
    const leagueMenu = useSelector(state => state.leagueMenu);

    useEffect(() => {
        dispatch(resetCurrentClub());
        dispatch(requestGames(isMobile));
    }, []);

    const createClub = () => {
        if (config.createClubWithCode) {
            dispatch(openDialog('createClubCode',
                {
                    title: 'createAClub',
                    smallSize: true,
                    slimHeader: true
                }));
        } else {
            dispatch(openDialog('createClub'));
        }
    }
    const joinClub = () => {
        dispatch(openDialog('joinClub',
            {
                smallSize: true,
                slimHeader: true
            }));
    }

    return (
        <div className={`mainClubs ${leagueMenu ? 'released' : 'expanded'}`}>
            <div className={`clubTitle ${(clubsData.length <= 1) ? 'hiddenTitleButtons' : ''}`}>
                <button className="secondary"  onClick={joinClub}>{t('joinClub')}</button>
                <button className="primary" onClick={createClub}>{t('createClub')}</button>
            </div>
            {
                (!!clubsData && clubsData.length > 1) ? <ClubList /> : <Emptylist create={createClub} join={joinClub} />
            }

            <LeagueGamesMenu />
        </div >);
};

export default withRouter(Home);
